import { PublicConfig, useViaductApi } from "@/viaduct-api";
import { PropsWithChildren, useEffect, useState } from "react";
import { ConfigContext } from "./configContext";

export const ConfigProvider = ({ children }: PropsWithChildren) => {
  const [config, setConfig] = useState<PublicConfig>();
  const [fetching, setFetching] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { client } = useViaductApi();

  const fetchConfig = async () => {
    setFetching(true);

    try {
      const configResult = await client.configGet();

      if (configResult.error) {
        // TODO: flag error for user
      }

      if (typeof configResult.data !== "undefined") {
        setConfig(configResult.data);
        setLoaded(true);
      }
    } catch (e) {}

    setFetching(false);
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, fetching, loaded }}>
      {children}
    </ConfigContext.Provider>
  );
};
